export default "__VITE_ASSET__Dng2ewqM__"